import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

 private socket: Socket;
private readonly uri: string = environment.socketUrl;

  constructor() {
    this.socket = io(this.uri);
    // For debugging, add:
    this.socket.on('connect', () => {
    });
    this.socket.on('connect_error', (err) => {
    });
  }

  onUserLiked(callback: (data: any) => void) {
  this.socket.on('userLiked', callback);
}

registerUser(userId: string) {
  this.socket.emit('register', userId);
}

}
